var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCropOriginalFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 13.0417V1.95833C14.625 1.0875 13.9125 0.375 13.0417 0.375H1.95833C1.0875 0.375 0.375 1.0875 0.375 1.95833V13.0417C0.375 13.9125 1.0875 14.625 1.95833 14.625H13.0417C13.9125 14.625 14.625 13.9125 14.625 13.0417ZM4.72917 8.6875L6.70833 11.0704L9.47917 7.5L13.0417 12.25H1.95833L4.72917 8.6875Z",
    fill: "#0D6EFD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropOriginalFill);
export default __webpack_public_path__ + "static/media/CropOriginalFill.1bcfa5b9.svg";
export { ForwardRef as ReactComponent };